import MenuIcon from '@mui/icons-material/Menu';
import {Grid, IconButton} from '@mui/material';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

import {APP_ROUTES, BREAKPOINTS} from '../../../const';
import useBreakpoint from '../../../hooks/dom/useBreakpoint';
import useMainSidebar from '../../../hooks/providers/useMainSidebar';
import useReport from '../../../hooks/providers/useReport';
import LogoSvg from '../../../img/company-logo';
import HeaderAdminModeIndicator from '../HeaderAdminModeIndicator/HeaderAdminModeIndicator';
import HeaderDesktopIcons from '../HeaderDesktopIcons/HeaderDesktopIcons';
import HeaderTrialProgressBar from '../HeaderTrialProgressBar/HeaderTrialProgressBar';
import HeaderUpgradeSubscriptionButton from '../HeaderUpgradeSubscriptionButton/HeaderUpgradeSubscriptionButton';
import HeaderOnboardingButtonIconOnly from '../onboarding/HeaderOnboardingButtonIconOnly/HeaderOnboardingButtonIconOnly';
import HeaderOnboardingButtonWithProgressPercentage from '../onboarding/HeaderOnboardingButtonWithProgressPercentage/HeaderOnboardingButtonWithProgressPercentage';
import HeaderOnboardingIframe from '../onboarding/onbarding-help-ressources/HeaderOnboardingIframe/HeaderOnboardingIframe';
import UserComponent from '../UserComponent/UserComponent';

const LogoContainer = styled.div`
  img {
    min-height: 50px;
    max-height: 64px;
  }

  top: 0;
  left: 40px;
  display: flex;

  @media screen and (max-width: 900px) {
    left: 12px;
  }

  @media screen and (max-width: 600px) {
    img {
      min-height: 40px;
      max-height: 64px;
    }
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding: 0 20px;

  @media screen and (max-width: 900px) {
    padding: 0;
  }
`;

const HeaderContainer = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  background-color: ${import.meta.env.VITE_MAIN_COLOR};
  z-index: 1300;
`;

const IconsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  max-width: 100%;

  @media screen and (max-width: 360px) {
    max-width: 100px;
  }

  @media screen and (min-width: 360px) and (max-width: 400px) {
    max-width: 160px;
  }

  @media screen and (min-width: 400px) and (max-width: 600px) {
    max-width: 200px;
  }
`;

const MobileMenuContainer = styled.div`
  border-right: solid 1px rgba(255, 255, 255, 0.1);
  padding: 0 4px;
`;

const AppHeader = () => {
  const currentBreakpoint = useBreakpoint();
  const {isReportAndModulesMobileDrawerOpen, setIsReportAndModulesMobileDrawerOpen} = useMainSidebar();
  const {reports} = useReport();

  const isSmallScreen = currentBreakpoint === BREAKPOINTS.xs;

  return (
    <HeaderContainer>
      <Header>
        {isSmallScreen && (
          <div>
            {reports.length > 0 ? (
              <MobileMenuContainer>
                <IconButton
                  disableRipple
                  disableFocusRipple
                  aria-label="menu"
                  sx={{
                    background: isReportAndModulesMobileDrawerOpen ? 'white' : '#ffffff15'
                  }}
                  onClick={e => setIsReportAndModulesMobileDrawerOpen(!isReportAndModulesMobileDrawerOpen)}
                >
                  <MenuIcon color={isReportAndModulesMobileDrawerOpen ? 'primary' : 'white'} sx={{fontSize: 18}} />
                </IconButton>
              </MobileMenuContainer>
            ) : null}
          </div>
        )}

        <Grid container alignItems="center" flex={1} flexWrap="nowrap" justifyContent="space-between">
          <LogoContainer>
            <Link to={APP_ROUTES.home}>
              <LogoSvg />
            </Link>
          </LogoContainer>

          <Grid item>
            <Grid container alignItems="center" flexWrap="nowrap">
              <HeaderAdminModeIndicator />
              <HeaderOnboardingButtonWithProgressPercentage />
              <HeaderOnboardingButtonIconOnly />

              <IconsContainer>{!isSmallScreen && <HeaderDesktopIcons />}</IconsContainer>

              <HeaderUpgradeSubscriptionButton />
              <HeaderTrialProgressBar variant={BREAKPOINTS.sm} />
            </Grid>
          </Grid>
        </Grid>

        <UserComponent />
      </Header>

      <HeaderOnboardingIframe />
    </HeaderContainer>
  );
};

export default AppHeader;
